import React from "react";
import { navigate } from "gatsby";

import MENU_PATHS from "../../constants/menu";
import { COLORS } from "../../utils/colors";

import Slider from "../slider";
import PilotProgramBox from "./box/PilotProgramBox";
import Button from "../buttons/Button";
import { getPartnersPilotPrograms } from "../../services/partner.service";

const PilotPrograms = () => {
  const handleSeeAll = () => {
    navigate(MENU_PATHS.PARTNERS);
  };

  const partnersPilotPrograms = getPartnersPilotPrograms();
  
  
  return (
    <div className="a-pilotPrograms fullWidth spacing-50">
      <div className="_wr">
        <div className="_w">
          <div className="_12">
            <p className="-title sectionTitle text-darkBlue -mb10 text-centered">
              Pilot Program Partners
            </p>
            <p className="-title boxTitle text-centered fullWidth">
              Building the Future of Diving—Together
            </p>
          </div>
          <div className="_12 ofs_l2 _l8">
            <p className="text-centered fullWidth -mt10 description14">
              Through the Skill N Depth Pilot Program, we collaborate with
              forward-thinking companies, trade associations, and technology
              innovators to shape the next generation of digital tools for the
              commercial diving industry. These partnerships allow us to
              co-develop, test, and improve real-world solutions that bring
              clarity, compliance, and connectivity to underwater operations.
            </p>
          </div>
          <div className="_12 -mt30">
            <Slider
              arr={partnersPilotPrograms}
              itemsPerPage={4}
              renderItem={PilotProgramBox}
            />
          </div>
          <div className="row -column-gap4 -mt30 -readMoreBtn justify-center fullWidth">
            <Button
              handleClick={handleSeeAll}
              name="See all partners"
              icon
              iconColor={COLORS.white}
              buttonClass="secondary"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PilotPrograms;
